import React from 'react';
import { Link } from 'react-router-dom';

const Emotional = () => {
    return (
        <div className="page-container emotional-page">
            <h1 className="page-title">Emotional Well-being</h1>

            {/* Include the image */}
            <img
                src="/images/wf-emotional2.jpg" // Path to image in public folder
                alt="Person meditating"
                className="page-image"
            />

            <p className="page-text">Welcome to the Emotional Well-Being section of Wholeness Forward.</p>

            <p className="page-text">
                Emotional well-being involves understanding, managing, and expressing our emotions in healthy ways. 
                It refers to the ability to cope with stress, maintain a positive outlook, and navigate life's challenges with emotional resilience. 
                Our emotions play a significant role in shaping how we experience the world and interact with others.
            </p>
            <p className="page-text">
                Healthy emotional well-being helps us to manage feelings like anger, sadness, or anxiety and fosters positive emotions like happiness, contentment, and gratitude. 
                It involves developing emotional intelligence, which enables us to recognize and regulate our emotions effectively.
            </p>

            <hr className="page-divider" />
            
            <p className="page-text">
                At Wholeness Forward, we aim to support you in building emotional resilience and developing the tools to navigate your emotional landscape. 
                Whether you’re managing stress, seeking emotional balance, or improving your emotional intelligence, we offer resources and insights to guide you along the way.
            </p>

            <h2 className="page-heading">Subtopics</h2>
            <ul className="content-list">
                <li><Link to="/emotional/stress" className="content-link">Managing Stress</Link></li>
                <li><Link to="/emotional/resilience" className="content-link">Building Emotional Resilience</Link></li>
                <li><Link to="/emotional/emotionalintelligence" className="content-link">Emotional Intelligence</Link></li>
            </ul>

            <hr className="page-divider" />

            <h3 className="subheading">Community Emotional Discussion</h3>
            <p className="page-text">
                Join the conversation with others who are working on their emotional well-being. Share your experiences, ask questions, and connect with a supportive community. 
                Whether you’re seeking tips for managing stress or exploring emotional resilience, your voice is valuable in this journey of emotional growth.
            </p>
            <a href="/forum/Emotional" className="btn">Join the Forum</a>
        </div>
    );
};

export default Emotional;
